import { jsx, jsxs } from 'react/jsx-runtime';
import classnames from 'classnames';
import { IconSize } from '../../lib/constants.js';
import { Button } from '../Button/index.js';
import { Icon as IconMemo } from '../Icon/index.js';
import ownClasses from './notice.module.scss.js';

const Notice = ({ children, variant, size, dark = false, icon, contentCentered = false, buttonConfiguration, closeConfiguration, classes = [], }) => {
    const content = typeof children !== 'string' ? (children) : (jsx("p", { className: `body-text ${size === 'small' ? 'small' : 'normal'}`, children: children }));
    return (jsxs("article", { className: classnames(ownClasses.notice, ownClasses[`notice--${variant}--${dark ? 'solid' : 'lite'}`], {
            [ownClasses['content-centered']]: contentCentered,
            'theme-redCorporate': variant === 'error',
            'theme-yellowMarket': variant === 'alert',
            'theme-greenLavoro': variant === 'success',
            'theme-blueMotori': variant === 'informative',
        }, ...classes), children: [icon !== undefined ? (jsx(IconMemo, { name: icon, iconSize: size === 'small' ? IconSize.SM : IconSize.MD, fillColor: "currentColor", classes: [ownClasses['notice-icon']] })) : null, jsx("div", { className: classnames(ownClasses['content-wrapper']), children: content }), buttonConfiguration !== undefined ? (jsx(Button, { design: dark ? 'outline-white' : 'solid', size: "medium", onClick: () => {
                    buttonConfiguration.onClick();
                }, children: buttonConfiguration.text })) : null, closeConfiguration !== undefined ? (jsx(Button, { design: "text", size: "small", onClick: () => {
                    closeConfiguration.onClick();
                }, icon: jsx(IconMemo, { name: "Close" }), children: jsx("span", { hidden: true, "aria-hidden": "false", children: "Chiudi" }) })) : null] }));
};

export { Notice };
//# sourceMappingURL=index.js.map
